<template>
  <div v-bind="$attrs">
    <SoButton
      :id="uniqueButtonId"
      :title="label"
      :icon="icon ?? (isOpen ? 'chevron-up' : 'chevron-down')"
      :large="large"
      :type="buttonType"
      :loading="loading"
      data-testid="so-menu-btn"
    />
    <v-menu
      ref="so-menu"
      v-model="isOpen"
      :close-on-content-click="autoclose"
      :activator="activator ?? `#${uniqueButtonId}`"
      data-testid="so-menu"
      open-delay="100"
      :max-width="maxWidth"
      :max-height="maxHeight"
      :class="menuClass"
      :loading="loading"
    >
      <v-list>
        <slot>
          <SoMenuItem
            v-for="(item, index) in items"
            :key="index"
            :title="item.title"
            :icon="item.icon"
            :disabled="item.disabled"
            :action="item.action"
            data-testid="so-menu-item"
            @click="() => $emit('itemClick', item.value)"
          />
        </slot>
      </v-list>
    </v-menu>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoMenuItem from "./SoMenuItem.vue"

  export type SoMenuItemType = {
    title: string
    value?: string
    icon?: string
    disabled?: boolean
    action?: () => void
  }

  export default defineComponent({
    components: {
      SoButton,
      SoMenuItem,
    },
    inheritAttrs: false,
    props: {
      modelValue: {
        type: Boolean,
        default: false,
      },
      label: {
        type: String,
        default: null,
      },
      items: {
        type: Array as PropType<SoMenuItemType[]>,
        default: () => [],
      },
      icon: {
        type: String,
        default: null,
      },
      large: {
        type: Boolean,
        default: false,
      },
      autoclose: {
        type: Boolean,
        default: true,
      },
      maxWidth: {
        type: String,
        default: null,
      },
      maxHeight: {
        type: String,
        default: null,
      },
      activator: {
        type: String,
        default: null,
      },
      menuClass: {
        type: String,
        default: null,
      },
      buttonType: {
        type: String,
        default: "primary",
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["itemClick", "update:modelValue"],

    data() {
      return {
        isOpen: false,
        uniqueButtonId: null as string | null,
      }
    },
    watch: {
      modelValue(value: boolean) {
        this.isOpen = value
      },
      isOpen(value: boolean) {
        this.$emit("update:modelValue", value)
      },
    },
    created() {
      this.uniqueButtonId = `so-menu-btn-${this.$.uid}`
    },
  })
</script>
